import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { FAIRY_THEMES } from '../../constants/fairyThemes';
import { getFairyLine } from '../../services/fairyLinesService';
import FairyPanel from './FairyPanel';
import './fairy.css';

const getSituation = (notifications) => {
  if (!notifications || notifications.length === 0) return 'inactive';
  const last = notifications[0];
  if (last?.type === 'completed_got_sequel') return 'completed_got_sequel';
  return 'new_episode';
};

const getVars = (notifications, username) => {
  const last = notifications?.[0];
  return {
    username:      username || 'Viajero',
    animeTitle:    last?.payload?.animeTitle    || '',
    episodeNumber: last?.payload?.episodeNumber || '',
  };
};

const getPosition = (pathname) => {
  if (pathname.startsWith('/watch'))      return 'top-center';
  if (pathname.startsWith('/anime'))      return 'top-right';
  if (pathname.startsWith('/perfil'))     return 'top-left';
  if (pathname.startsWith('/mi-lista'))   return 'bottom-right';
  if (pathname.startsWith('/directorio')) return 'bottom-left';
  return 'bottom-right';
};

export default function FairyBell() {
  const { user, fairyAlerts, clearFairyAlerts, fairyId } = useAuth();
  const location = useLocation();

  const [open,        setOpen]        = useState(false);
  const [ringing,     setRinging]     = useState(false);
  const [currentLine, setCurrentLine] = useState('');

  // La hada solo reacciona a alertas live (fairy_notification WS), NO a notificaciones del bell
  const unread   = fairyAlerts.filter((a) => !a.read).length;
  const position = getPosition(location.pathname);
  const theme    = FAIRY_THEMES[fairyId] || FAIRY_THEMES.aurora;

  // Ring when new live alert arrives
  useEffect(() => {
    if (unread > 0) {
      setRinging(true);
      const t = setTimeout(() => setRinging(false), 2000);
      return () => clearTimeout(t);
    }
  }, [unread]);

  if (!user) return null;

  const handleOpen = () => {
    const opening = !open;
    if (opening) {
      setCurrentLine(
        getFairyLine(
          fairyId,
          getSituation(fairyAlerts),
          getVars(fairyAlerts, user?.username)
        ) || ''
      );
      clearFairyAlerts();
    }
    setOpen(opening);
  };

  const panelClass = position.startsWith('top')
    ? 'fairy-panel fairy-panel--from-top'
    : 'fairy-panel fairy-panel--from-bottom';

  return (
    <>
      <div
        className={`fairy-bell-wrapper fairy-pos-${position}${ringing ? ' ringing' : ''}`}
        style={{
          '--fairy-primary':   theme.primary,
          '--fairy-secondary': theme.secondary,
          '--fairy-glow':      theme.glow,
        }}
      >
        <div className="fairy-bell-orb" onClick={handleOpen}>
          <img
            src={`/fairies/${fairyId}.png`}
            alt={fairyId}
            className="fairy-bell-img"
          />
        </div>
        {unread > 0 && (
          <span className="fairy-bell-badge">{unread > 99 ? '99+' : unread}</span>
        )}
        <div className="fairy-bell-particles">
          {[...Array(5)].map((_, i) => (
            <span key={i} className="fairy-particle">{theme.particle}</span>
          ))}
        </div>
      </div>

      {open && (
        <FairyPanel
          fairyId={fairyId}
          theme={theme}
          notifications={fairyAlerts}
          currentLine={currentLine}
          panelClass={panelClass}
          position={position}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
